import { lazy, Suspense } from 'react';
import { PermissionGuard } from '@emfood/shared';
import { Outlet, createRoute, SearchSchemaInput } from '@tanstack/react-router';

import { PERMISSIONS } from 'src/api/roles-config';
import DashboardLayout from 'src/layouts/dashboard';

import AppAuthGuard from 'src/components/auth/app-auth-guard';
import { SplashScreen, LoadingScreen } from 'src/components/loading-screen';

import FinanceSearchParams from 'src/sections/finance/finance-search-params';

import { rootRoute } from './root';

const FinanceOrderList = lazy(() => import('src/sections/finance/view'));
const InvoiceDetails = lazy(() => import('src/sections/finance/invoice-details/view'));

// Finance routes
const financeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'finance',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <PermissionGuard requiredPermissions={[PERMISSIONS.FINANCE_READ]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </PermissionGuard>
    </AppAuthGuard>
  ),
});

const financeOrderListRoute = createRoute({
  getParentRoute: () => financeRoute,
  path: '/',
  component: FinanceOrderList,
  validateSearch: (search: unknown & SearchSchemaInput) => FinanceSearchParams.validateSync(search),
});

const financeOrderInvoiceDetailsRoute = createRoute({
  getParentRoute: () => financeRoute,
  path: 'invoices/$invoiceId',
  component: InvoiceDetails,
});

export const financeRouteTree = financeRoute.addChildren([
  financeOrderListRoute,
  financeOrderInvoiceDetailsRoute,
]);
